module.exports = __webpack_public_path__ + "img/cameraicon.6e2c8b6a.svg";